<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <!-- O topo do painel do Lumos (único uso desta peça). Era o nome solto com
       um ponto; agora é a FAIXA da marca do Lumos, a mesma gramática do
       cartão de entrar (navy que abre para a cor, trama de pontos, selo
       sólido no centro do assunto): quem abre o painel sabe onde está. -->
  <header class="sah">
    <span class="sah__selo" aria-hidden="true">
      <i class="i-ph-sparkle-fill" />
    </span>
    <div class="sah__txt">
      <p class="sah__titulo">{{ title }}</p>
      <p class="sah__sub">{{ $t('CAPTAIN.COPILOT.SUBTITULO') }}</p>
    </div>
    <div class="sah__acoes">
      <button
        v-for="button in buttons"
        :key="button.key"
        v-tooltip="button.tooltip"
        type="button"
        class="sah__acao"
        :aria-label="button.tooltip"
        @click="handleButtonClick(button)"
      >
        <i :class="button.icon" aria-hidden="true" />
      </button>
      <button
        v-tooltip="$t('GENERAL.CLOSE')"
        type="button"
        class="sah__acao"
        :aria-label="$t('GENERAL.CLOSE')"
        @click="emit('close')"
      >
        <i class="i-ph-x" aria-hidden="true" />
      </button>
    </div>
  </header>
</template>

<style scoped>
.sah {
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  min-height: 68px;
  padding: 12px 12px 12px 16px;
  overflow: hidden;
  background: radial-gradient(
      circle at 100% 0%,
      rgb(var(--violet-9) / 45%),
      transparent 55%
    ),
    linear-gradient(140deg, #0f1229 0%, #1e1b4b 55%, #3730a3 150%);
  color: #fff;
}

/* A trama de pontos do produto, apagando para a esquerda. */
.sah::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    rgb(255 255 255 / 12%) 1px,
    transparent 1px
  );
  background-size: 12px 12px;
  mask-image: linear-gradient(250deg, #000 0%, transparent 60%);
  pointer-events: none;
}

.sah__selo {
  position: relative;
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: linear-gradient(
    150deg,
    rgb(var(--iris-8)),
    rgb(var(--iris-9)) 45%,
    rgb(var(--violet-10))
  );
  box-shadow:
    inset 0 1px 0 rgb(255 255 255 / 40%),
    0 0 0 1px rgb(255 255 255 / 14%),
    0 8px 18px -8px rgb(var(--iris-9) / 95%);
  font-size: 19px;
  color: #fff;
}

.sah__txt {
  position: relative;
  flex: 1;
  min-width: 0;
}

.sah__titulo {
  margin: 0;
  font-family: var(--fonte-display, inherit);
  font-size: 16px;
  font-weight: 750;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #fff;
}

.sah__sub {
  margin: 1px 0 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(199 210 254 / 85%);
}

.sah__acoes {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
}

.sah__acao {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: transparent;
  font-size: 17px;
  color: rgb(224 231 255 / 80%);
  cursor: pointer;
  transition:
    background-color 0.15s cubic-bezier(0.16, 1, 0.3, 1),
    color 0.15s cubic-bezier(0.16, 1, 0.3, 1);
}

.sah__acao:hover {
  background: rgb(255 255 255 / 12%);
  color: #fff;
}

.sah__acao:focus-visible {
  outline: 2px solid rgb(165 180 252);
  outline-offset: 1px;
}
</style>
